import styled from 'styled-components';

export const GRID_ROW_MARGIN_BOTTOM = 24;
const LEARNING_CARD_WIDTH = 359;

export const CarouselWrapper = styled.div<{ $pageHeight?: string }>`
    width: 100%;
    height: ${({ $pageHeight }) => `${$pageHeight};`}
    overflow: visible;
`;

export const CarouselViewport = styled.div`
    overflow: hidden;
    width: 100%;
`;

export const CarouselContainer = styled.div`
    display: flex;
    width: 100%;
`;

export const CarouselSlide = styled.div<{ width?: string }>`
    flex: 0 0 ${({ width }) => width || '100%'};
    box-sizing: border-box;
    margin-left: 0.1rem;
`;

export const SlideGrid = styled.div<{ $columns: number }>`
    display: grid;
    grid-template-columns: repeat(${({ $columns }) => $columns}, ${LEARNING_CARD_WIDTH}px);
    gap: 18px;
`;
